export default __webpack_public_path__ + "static/media/3D.8d12a3fc.svg";